import React, { Suspense, useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import WhatsAppButton from './components/WhatsAppButton';
import SearchBar from './components/SearchTab'; 
import Modal from './components/Modal'; // Importing Modal component
// Preloader
const Preloader = React.lazy(() => import("./components/layouts/Preloader"));

// Home
const Hometwo = React.lazy(() => import("./components/pages/Hometwo"));
// Blog
const Bloggrid = React.lazy(() => import("./components/pages/Bloggrid"));
const Blogdetails = React.lazy(() => import("./components/pages/Blogdetails"));
// Pages
const About = React.lazy(() => import("./components/pages/About"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const Team = React.lazy(() => import("./components/pages/Team"));
const Faqs = React.lazy(() => import("./components/pages/Faqs"));
const Claims = React.lazy(() => import("./components/pages/Claims"));
const Careers = React.lazy(() => import("./components/pages/careers"));


// Cases
const Casestudies = React.lazy(() => import("./components/pages/Casestudies"));
const Casestudy = React.lazy(() => import("./components/pages/Casestudy"));
// Appointment
const Appointment = React.lazy(() => import("./components/pages/Appointment"));


// Scroll to Top
const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return children || null
})


function App() {
  const isHomePage = window.location.pathname === "/";
  return (
    <>
    {isHomePage && <Modal />}
    <Router basename={"/"}>
      <Suspense fallback={<div></div>}>
        <ScrollToTop>
          <Preloader />
          <SearchBar />
          <Switch>
            {/* Home */}
            <Route exact path="/" component={Hometwo} />
            {/* Blog */}
            <Route exact path="/blog/cat/:catId" component={props => (<Bloggrid {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/tag/:tagId" component={props => (<Bloggrid {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/author/:authorId" component={props => (<Bloggrid {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/search/:query" component={props => (<Bloggrid {...props} key={window.location.pathname} />)} />
            <Route exact path="/news" component={Bloggrid} />
            <Route exact path="/news/:id" component={props => (<Blogdetails {...props} key={window.location.pathname} />)} />
            {/* Pages */}
            <Route exact path="/about" component={About} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/team" component={Team} />
            <Route exact path="/faqs" component={Faqs} />
            <Route exact path="/claims" component={Claims} />
            <Route exact path="/careers" component={Careers} />
           
            {/* Cases */}
            <Route exact path="/case/cat/:catId" component={props => (<Casestudies {...props} key={window.location.pathname} />)} />
            <Route exact path="/services" component={Casestudies} />
            <Route exact path="/insurance/:id" component={props => (<Casestudy {...props} key={window.location.pathname} />)} />
            {/* Appointment */}
            <Route exact path="/quote" component={Appointment} />
          </Switch>
        </ScrollToTop>
      </Suspense>
    </Router>
    <WhatsAppButton />
    </>
  );
}

export default App;
